import { render, staticRenderFns } from "./PublicTitle.vue?vue&type=template&id=1144ef8e&scoped=true"
import script from "./PublicTitle.vue?vue&type=script&lang=js"
export * from "./PublicTitle.vue?vue&type=script&lang=js"
import style0 from "./PublicTitle.vue?vue&type=style&index=0&id=1144ef8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1144ef8e",
  null
  
)

export default component.exports